import { parsePhoneNumber, isValidPhoneNumber } from "libphonenumber-js";

/**
 * Formats a phone number according to the specified requirements:
 * - US and Canadian numbers (starting with +1): +1-xxx-xxx-xxxx format
 * - International numbers: Use libphonenumber-js formatting
 * @param phoneNumber The phone number to format
 * @returns Formatted phone number string or null if invalid
 */
export function formatPhoneNumber(
  phoneNumber: string | null | undefined,
): string | null {
  if (!phoneNumber) {
    return null;
  }

  // Clean the input
  const cleaned = phoneNumber.replace(/\D/g, "");

  // Handle US/Canadian numbers (10 digits or 11 digits starting with 1)
  if (cleaned.length === 10) {
    return `+1-${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    const nationalNumber = cleaned.slice(1);
    return `+1-${nationalNumber.slice(0, 3)}-${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
  }

  // Handle international numbers with libphonenumber-js
  try {
    const parsed = parsePhoneNumber(phoneNumber);

    if (!parsed || !isValidPhoneNumber(phoneNumber)) {
      return null;
    }

    // For US and Canadian numbers (+1), use the specific format +1-xxx-xxx-xxxx
    if (parsed.countryCallingCode === "1") {
      const nationalNumber = parsed.nationalNumber;
      if (nationalNumber.length === 10) {
        return `+1-${nationalNumber.slice(0, 3)}-${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
      }
    }

    // For international numbers, use the standard libphonenumber-js formatting
    return `+${parsed.countryCallingCode} ${parsed.formatNational()}`;
  } catch (error) {
    console.error("Error parsing phone number:", error);
    return null;
  }
}
